<sim-basic-material-dialog
	[headerText]="T.EXAM_PARTICIPANT_DEVICE_STUDENT_CLINICAL_VIGNETTE_TITLE | translate"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	(closeClicked)="close()"
	[overflowHandledByChild]="true"
>
	<div class="contentWrapper" dialogContent>
		<sim-clinical-vignette-view [clinicalVignetteText]="data.clinicalVignetteText" [hideHeader]="true" />

		@if (!hideRemainingTime()) {
			<div class="durationIndicator">
				<label class="secondaryLabel">
					<mat-icon fontSet="far" fontIcon="fa-clock" />
					{{ T.EXAM_PARTICIPANT_DEVICE_STUDENT_CLINICAL_VIGNETTE_REMAINING_TIME | translate }}
				</label>

				@let time = remainingTime();
				<span [class.counterFlash]="time <= 10 && time !== 0">
					{{ time * 1000 | durationLabel }}
				</span>
			</div>
		}
	</div>
</sim-basic-material-dialog>
